import { PROPERTY_USAGE_TYPE_ENUM, GSE_PROPERTY_TYPE_TO_LANIS } from "../constants";
import { DUPLEX_1_2, MULTI_UNIT_3_4, CONDOMINIUM, PUD } from "../../constants/property_type";
import { OWNER, SECOND_HOME, INVESTMENT_PROPERTY } from "../../constants/occupancy";

export function importPropertyAddress(obj, { document }) {
  if (obj.AddressLineText) document.property.address = obj.AddressLineText;
  if (obj.AddressAdditionalLineText) document.property.address2 = obj.AddressAdditionalLineText;
  if (obj.CityName) document.property.city = obj.CityName;
  if (obj.StateCode || obj.StateName) {
    document.property.state = obj.StateCode || obj.StateName;
  }
  if (obj.PostalCode) document.property.zip = obj.PostalCode;
}

const OCCUPANCY_FROM_USAGE = {
  PrimaryResidence: OWNER,
  SecondHome: SECOND_HOME,
  Investor: INVESTMENT_PROPERTY,
  InvestmentProperty: INVESTMENT_PROPERTY
};

export function importPropertyDetail(obj, { document }) {
  if (obj.PropertyUsageType) {
    for (const [id, label] of Object.entries(PROPERTY_USAGE_TYPE_ENUM)) {
      if (label === obj.PropertyUsageType) {
        document.property.classification = id;
        break;
      }
    }
    // Occupancy is a separate LANIS field; PrimaryResidence => Owner-occupied.
    if (OCCUPANCY_FROM_USAGE[obj.PropertyUsageType]) {
      document.property.occupancy = OCCUPANCY_FROM_USAGE[obj.PropertyUsageType];
    }
  }
  if (obj.GSEPropertyType) {
    const lanisPropType = GSE_PROPERTY_TYPE_TO_LANIS[obj.GSEPropertyType];
    if (lanisPropType) {
      document.property.property_type = lanisPropType;
    }
  }
  const unitCount = parseInt(obj.FinancedUnitCount, 10);
  if (!isNaN(unitCount) && !obj.GSEPropertyType) {
    if (unitCount === 2) document.property.property_type = DUPLEX_1_2;
    else if (unitCount >= 3) document.property.property_type = MULTI_UNIT_3_4;
  }
  // Attachment Type ("Attached" / "Detached") — POINT keeps this separate from
  // Property Type. The values already match the LANIS attachment_type constant.
  if (obj.AttachmentType) {
    document.property.attachment_type = obj.AttachmentType;
  }
  // PUD — POINT (and our own export) sends a PUD as PUDIndicator=true with no
  // GSEPropertyType, so without this a PUD round-tripped back in as blank.
  // Don't override a more specific type already set above (units / GSE).
  if (
    (obj.PUDIndicator === "true" || obj.PUDIndicator === true) &&
    !document.property.property_type
  ) {
    document.property.property_type = PUD;
  }
  // Estimated property value -> listed_price. This is the Refinance "Market
  // Value" (Purchase uses the sales price via SalesContractAmount, imported
  // after this and taking precedence). Without this a refinance round-trip left
  // Market Value blank, which made LTV divide by 0 (Infinity%).
  const currentListed = document.property.listed_price;
  if (
    obj.PropertyEstimatedValueAmount != null &&
    (!currentListed || currentListed === "0")
  ) {
    document.property.listed_price = String(obj.PropertyEstimatedValueAmount);
  }
}

// Sales price -> listed_price (purchase price). LOAN @item copies this to
// loan.offer_price (COLLATERALS is imported before LOANS).
export function importSalesContractDetail(obj, { document }) {
  if (obj.SalesContractAmount != null) {
    document.property.listed_price = String(obj.SalesContractAmount);
  }
}

// Appraised / valuation amount -> listed_price when no sales price was provided.
export function importPropertyValuation(obj, { document }) {
  const current = document.property.listed_price;
  if (obj.PropertyValuationAmount != null && (!current || current === "0")) {
    document.property.listed_price = String(obj.PropertyValuationAmount);
  }
}

// Condo project -> Property Type = Condominium (also reveals the HOA fields).
export function importProjectDetail(obj, { document }) {
  if (obj.ProjectLegalStructureType === "Condominium") {
    document.property.property_type = CONDOMINIUM;
  } else if (obj.ProjectLegalStructureType === "PlannedUnitDevelopment") {
    document.property.property_type = PUD;
  }
}
